import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { ApiService, HttpParamsOptions } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Config } from 'datatables.net';
import { Router, ActivatedRoute } from "@angular/router";
declare const $: any;
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceInRequiredValidator } from '../../shared/constants';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours, addMinutes, addMonths } from 'date-fns';

class DataTablesResponse {
	data!: any[];
	draw!: number;
	recordsFiltered!: number;
	recordsTotal!: number;
}

@Component({
	selector: 'app-invoice-create',
	templateUrl: './invoice-create.component.html',
	styleUrl: './invoice-create.component.css'
})
export class InvoiceCreateComponent implements OnInit, AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/invoice-list",
			name: "Invoice"
		}
	];
	uId: any = null;
	pagetitle = "Create Invoice";
	moduleForm!: FormGroup;
	showLoader: boolean = false;
	pageLoading: boolean = false;
	details: any = null;
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	baseURL = environment.API_URL;
	dtOptions: Config = {};
	dataList: any = [];
	allFlagStates: any[] = [];
	flagState: any = null;
	apptModuleAccess: any = "Full";
	accessLoader = false;
	companyList: any[] = [];
	vesselList: any[] = [];
	/* branchList: any[] = []; */
	currencyList: any[] = [];
	/* pay_mod_list = [{ 'id': 1, 'pay_mod': 'Candidate' }, { 'id': 2, 'pay_mod': 'Company' }, { 'id': 3, 'pay_mod': 'NA' }];
	paymentList = [{ id: 1, name: "Cash" }, { id: 1, name: "Razorpay" }, { id: 1, name: "Bank TFR" }, { id: 2, name: "Company" }, { id: 3, name: "NA" }, { id: 4, name: "Not Done" }]; */
	unique_all = [{ val: 0, name: "All" }, { val: 1, name: "Unique" }];
	checkAll = false;
	selectedAppts: any[] = [];
	existingAppts: any[] = [];

	constructor(private toastr: ToastrService, private router: Router, private activeRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService, private http: HttpClient) { }

	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
			this.moduleForm = this.formBuilder.group({
				company: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				invoice_no: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				fromDate: [null/* , [Validators.required] */],
				toDate: [null/* , [Validators.required] */],
				invoice_date: [null, [Validators.required]],
				due_date: [null, [Validators.required]],
				currency: [null, [Validators.required]],
				test_fee: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(/^([0-9]+(\.?[0-9]?[0-9]?)?)$/)]],
				amount: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
				/* branch: [[]], */
				/* branch: [null], */
				vessel: [null],
				unique: [1],
				/* pay_mod: [[]],
				payment: [[]], */
				number_of_vessel: [null]
			});
			this.f.invoice_no.disable();
			/* this.f.amount.disable(); */
			this.getCompanyList();
			this.getCurrencyList();
			if (this.uId) {
				this.breadcrumbList.push({ path: "/app/edit-invoice/" + this.uId, name: "Edit" });
				this.pagetitle = "Edit Invoice";
				this.getDetails();
			} else {
				this.breadcrumbList.push({ path: "/app/create-invoice", name: "Create" });
				this.initDatatable();
				this.get_invoice_number();
			}
		});
	}

	get_invoice_number() {
		this.apiService.get_invoice_number().subscribe({
			next: (data: any) => {
				this.f.invoice_no.setValue(data);
			}, error: (error) => {
				if (error.status == 401) { return }
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	invoiceDateChanged() {
		if (this.f.invoice_date.value) {
			this.f.due_date.setValue(addMonths(this.f.invoice_date.value, 1));
		} else {
			this.f.due_date.setValue(null);
		}
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getInvoiceDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.details = data;
				this.f.company.setValue(this.details.company);
				this.f.invoice_no.setValue(this.details.invoice_no);
				this.f.fromDate.setValue(this.apiService.getDateFromDateStringDDMMYYYY(this.details.fromDate));
				this.f.toDate.setValue(this.apiService.getDateFromDateStringDDMMYYYY(this.details.toDate));
				this.f.invoice_date.setValue(this.apiService.getDateFromDateStringDDMMYYYY(this.details.invoice_date));
				this.f.due_date.setValue(this.apiService.getDateFromDateStringDDMMYYYY(this.details.due_date));
				this.f.currency.setValue(this.details.currency);
				this.f.test_fee.setValue(this.details.test_fee);
				this.f.amount.setValue(this.details.amount);
				/* this.f.branch.setValue(this.details.branch ? this.details.branch : []); */
				/* this.f.branch.setValue(this.details.branch); */
				this.f.vessel.setValue(this.details.vessel ? parseInt(this.details.vessel) : null);
				this.f.unique.setValue(this.details.unique == undefined ? 0 : this.details.unique);
				/* this.f.pay_mod.setValue(this.details.pay_mod ? this.details.pay_mod : []);
				this.f.payment.setValue(this.details.payment ? this.details.payment : []); */
				this.f.number_of_vessel.setValue(this.details.number_of_vessel);
				this.selectedAppts = JSON.parse(JSON.stringify(this.details.appt_list));
				this.existingAppts = JSON.parse(JSON.stringify(this.details.appt_list));
				this.initDatatable();
				this.getVesselListByCompany(false);
				this.showHideNoOfCandidates();
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	get f() { return this.moduleForm.controls; }

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			ajax: (dataTablesParameters: any, callback) => {
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length
				}
				if (dataTablesParameters.search.value != "") {
					data.search = dataTablesParameters.search.value;
				}
				if (this.f.company.value) {
					data["company"] = this.f.company.value;
				}
				/* if (this.f.branch.value) {
					data["branch"] = this.f.branch.value;
				} */
				if (this.f.vessel.value) {
					data["vessel"] = this.f.vessel.value;
				}
				if (this.f.fromDate.value) {
					data["fromDate"] = this.apiService.getDateStringFromDateDDMMYYYY(this.f.fromDate.value);
				}
				if (this.f.toDate.value) {
					data["toDate"] = this.apiService.getDateStringFromDateDDMMYYYY(this.f.toDate.value);
				}
				const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
				this.http.get<DataTablesResponse>(this.baseURL + "listappt", { params: new HttpParams(httpParams) }).subscribe({
					next: (response: any) => {
						let checkAll = true;
						for (let i = 0; i < response.data.length; i++) {
							response.data[i].appt_obj_list = JSON.parse(JSON.stringify(response.data[i].appt_list));
							response.data[i].appt_list = [];
							for (let j = 0; j < response.data[i].appt_obj_list.length; j++) {
								response.data[i].appt_list.push(response.data[i].appt_obj_list[j].id);
							}
							if (response.data[i].numberOfCandidate !== null && response.data[i].numberOfCandidate > response.data[i].appt_list.length) {
								let x = 1;
								while (response.data[i].appt_list.length < response.data[i].numberOfCandidate) {
									response.data[i].appt_list.push("customId-" + response.data[i].ref_no + "-" + x);
									x++;
								}
							}
							if (response.data[i].appt_list.length && this.selectedAppts.indexOf(response.data[i].appt_list[0]) >= 0) {
								response.data[i].checked = true;
							}
							if (!response.data[i].checked) {
								checkAll = false;
							}
						}
						this.checkAll = checkAll;
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error!!!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	refreshTable() {
		this.checkAll = false;
		this.selectedAppts = [];
		if (this.datatableElement) {
			this.datatableElement.dtInstance.then((dtInstance) => {
				dtInstance.draw();
			});
		}
	}

	getCurrencyList() {
		this.apiService.getCurrency({}).subscribe({
			next: (data: any) => {
				this.currencyList = data;
			}, error: (err: any) => {
				this.currencyList = [];
			}
		});
	}

	getCompanyList() {
		this.apiService.getAllCompanyList().subscribe({
			next: (data: any) => {
				this.companyList = data;
			}, error: (error) => {
				this.companyList = [];
				if (error.status == 401) { return }
			}
		});
	}

	getVesselListByCompany(clearVessel: boolean) {
		if (clearVessel) {
			this.f.vessel.setValue(null);
		}
		if (this.f.company.value) {
			this.apiService.getVesselListByCompany({ company: this.f.company.value }).subscribe({
				next: (data: any) => {
					this.vesselList = data;
				}, error: (error) => {
					this.vesselList = [];
				}
			});
		} else {
			this.vesselList = [];
		}
	}

	/* getBranchListByCompany(clearBranch: boolean) {
		if (clearBranch) {
			this.f.branch.setValue(null);
		}
		if (this.f.company.value) {
			this.apiService.getBranchListByCompany({ company: this.f.company.value }).subscribe({
				next: (data: any) => {
					this.branchList = data;
				}, error: (error) => {
					this.branchList = [];
				}
			});
		} else {
			this.branchList = [];
		}
	} */

	checkUncheckAll(checked: any) {
		let len = this.dataList.length;
		for (let i = 0; i < len; i++) {
			this.dataList[i].checked = checked;
			this.apptSelected(this.dataList[i].appt_list, this.dataList[i].ref_no, checked);
		}
	}

	apptSelected(appt_list: any, ref_no: any, checked: any) {
		if (checked) {
			this.selectedAppts = this.selectedAppts.concat(JSON.parse(JSON.stringify(appt_list)));
		} else {
			for (let i = 0; i < appt_list.length; i++) {
				this.selectedAppts = this.selectedAppts.filter((n: any) => n !== appt_list[i]);
			}
		}
		this.selectedAppts = this.selectedAppts.filter((n: any, i: any) => this.selectedAppts.indexOf(n) === i);
		let len = this.dataList.length;
		let checkAll = true;
		for (let i = 0; i < len; i++) {
			if (!this.dataList[i].checked) {
				checkAll = false;
			}
		}
		this.checkAll = checkAll;
		this.getAmount();
	}

	getAmount() {
		this.f.amount.setValue(null);
		let amount: any = this.f.test_fee.value * (this.showNoOfCandidates ? this.f.number_of_vessel.value : this.selectedAppts.length);
		amount = this.roundNumber(amount);
		this.f.amount.setValue(amount);
	}

	roundNumber(number: number, decimal_digit: number = 2) {
		let powerOften = Math.pow(10, decimal_digit);
		let result = Math.round(number * powerOften) / powerOften;
		let amtStr = result.toString();
		let amtArr = amtStr.split(".");
		let beforeDecimal = amtArr[0];
		let finalAmountStr = beforeDecimal;
		var afterDecimal = amtArr[1] == undefined ? "" : amtArr[1];
		while (afterDecimal.length < decimal_digit) {
			afterDecimal = afterDecimal + "0";
		}
		finalAmountStr = finalAmountStr + "." + afterDecimal;
		return finalAmountStr;
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		if (!this.showNoOfCandidates && this.selectedAppts.length == 0) {
			this.toastr.error("No appointments selected", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let selectedAppts: any[] = JSON.parse(JSON.stringify(this.selectedAppts));
		selectedAppts = selectedAppts.filter((id: any) => {
			return id.toString().indexOf("customId-") == -1;
		})
		let payload: any = {
			company: this.f.company.value,
			invoice_no: this.f.invoice_no.value,
			invoice_date: this.apiService.getDateStringFromDateDDMMYYYY(this.f.invoice_date.value),
			due_date: this.apiService.getDateStringFromDateDDMMYYYY(this.f.due_date.value),
			currency: this.f.currency.value,
			test_fee: this.f.test_fee.value,
			amount: this.f.amount.value,
			/* branch: this.f.branch.value, */
			/* pay_mod: this.f.pay_mod.value,
			payment: this.f.payment.value, */
			unique: parseInt(this.f.unique.value),
			appt_count: this.selectedAppts.length,
			appt_list: selectedAppts
		};
		if (this.f.vessel.value) {
			payload["vessel"] = this.f.vessel.value;
		}
		if (this.f.number_of_vessel.value) {
			payload["number_of_vessel"] = parseInt(this.f.number_of_vessel.value);
		}
		if (this.f.fromDate.value) {
			payload["fromDate"] = this.apiService.getDateStringFromDateDDMMYYYY(this.f.fromDate.value);
		}
		if (this.f.toDate.value) {
			payload["toDate"] = this.apiService.getDateStringFromDateDDMMYYYY(this.f.toDate.value);
		}
		if (this.uId) {
			payload["id"] = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateInvoice(payload).subscribe({
			next: data => {
				this.showLoader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.gotoList();
			}, error: (error: any) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg: any = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							let val: any = value;
							if (val == "This field must be unique.") {
								val = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val;
								let selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val, 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						}
						return;
					}
				} else {
					errorMsg = error.error;
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	gotoList() {
		this.router.navigate(['/app/invoice-list']);
	}

	showNoOfCandidates = false;
	showHideNoOfCandidates() {
		const compNames = ["3 Cube", "3 Cube Medicare Pte. Ltd.", "3 Cube Medicare "];
		const companyName = this.getCompanyName(this.f.company.value);
		if (this.f.company.value && compNames.includes(companyName)) {
			this.f.number_of_vessel.setValidators([Validators.required, Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]);
			this.f.number_of_vessel.updateValueAndValidity();
			this.showNoOfCandidates = true;
			/* this.f.amount.enable(); */
		} else {
			this.f.number_of_vessel.setValue(null);
			this.f.number_of_vessel.setValidators(null);
			this.f.number_of_vessel.updateValueAndValidity();
			this.showNoOfCandidates = false;
			/* this.f.amount.disable(); */
		}
	}

	getCompanyName(id: any) {
		const len = this.companyList.length;
		for (let i = 0; i < len; i++) {
			if (this.companyList[i].apptid == id) {
				return this.companyList[i].comp_name
			}
		}
		return "";
	}
}
